import styled, { css } from 'styled-components'
import { Modal, Text, Image, RadioButton, TabList } from '@sketch/components'

export const StyledModal = styled(Modal)`
  max-width: 700px;
  overflow-y: hidden;

  ${Modal.Body} {
    height: 400px;
    overflow-y: auto;
  }
`

// this override is necessary because two Text elements always result on a 20px padding on the first one
export const Title = styled(Text).attrs({
  fontSize: 'G',
  fontWeight: 'regular',
})`
  padding-bottom: 4px !important; /* stylelint-disable-line declaration-no-important */
`

export const PreviewImage = styled(Image)(
  ({ theme }) => css`
    max-width: 92px;
    max-height: 92px;

    img {
      border-radius: ${theme.radii.large};
      border: 1px solid ${theme.colors.border.A};
      max-width: 92px;
      max-height: 92px;
    }
  `
)

export const PreviewImageEmpty = styled.div(
  ({ theme }) => css`
    width: 92px;
    height: 92px;
    border-radius: ${theme.radii.large};
    border: 1px solid ${theme.colors.border.A};
    background-color: ${theme.colors.background.tertiary.D};
    position: relative;

    ::after {
      content: ' ';
      width: 42px;
      height: 42px;
      border-radius: 50%;
      background-color: ${theme.colors.background.tertiary.B};
      position: absolute;
      top: 34px;
      right: 16px;
    }

    ::before {
      content: ' ';
      width: 38px;
      height: 38px;
      background-color: ${theme.colors.background.tertiary.B};
      position: absolute;
      top: 18px;
      left: 18px;
    }
  `
)

export const StyledTabList = styled(TabList)`
  padding-bottom: 24px;
  margin-bottom: 24px;
  /* negative margins and paddings are necessary for the all width border */
  margin-left: -32px;
  padding-left: 32px;
  margin-right: -32px;
  padding-right: 32px;
  position: fixed;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  border-color: ${({ theme }) => theme.colors.border.A};
  /* needed so the tab list is on top of the radio buttons */
  z-index: 50;
`

// this is the necessary padding for the fixed tab list (which is 60px tall, 24px are the top padding)
export const TabPanelWrapper = styled.div`
  padding-top: 84px; /* stylelint-disable-line scales/space */
`

export const StyledRadioButton = styled(RadioButton)`
  margin-bottom: 12px;
`
